import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'

const useDeleteSeries = () => {
	const navigate = useNavigate()
	const {idx} = useParams()
	const [userRole] = useRoleCookie()

	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	const clickEvent = () => {
		let url = `/admin/series/${idx}`

		fetchRequest('DELETE', url)
	}

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 200:
				navigate(-1)
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('대회 시리즈 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [clickEvent]
}

export default useDeleteSeries
